import { render, staticRenderFns } from "./Gears.vue?vue&type=template&id=0960841a"
import script from "./Gears.vue?vue&type=script&lang=js"
export * from "./Gears.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports